import Footer from "../components/footer"
import GlobalSection from "../components/GlobalSection"
import Header from "../components/header"

const Service=()=>{
    return(
        <>
        {<Header/>}
        {<GlobalSection/>}
       
        </>
    )
}
export default Service